export function getLanguageByKey(json, key, rootJson, isRoot) {
    if(isRoot == true) {
        if (rootJson[key] != null) {
            return rootJson[key];
        }
        else {
            return key;
        }
    }
    else {
        if (json[key] != null) {
            return json[key];
        }
        else {
            return key;
        }        
    }
}